export const FETCH_POSITION_REQUEST = "FETCH_POSITION_REQUEST";
export const FETCH_POSITION_SUCCESS = "FETCH_POSITION_SUCCESS";
export const FETCH_POSITION_FAIL = "FETCH_POSITION_FAIL";
